export default __webpack_public_path__ + "static/media/a011-example11_tc.94ae2166.png";